import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { apiSimulation, SimulationReq, SimulationResult, SimulationRes } from '../../api/selfApi'
import { defaultSelectedIdx } from '../../js/simulationChart'

export interface SimulationState {
  result: SimulationResult | undefined
  responseCode: number
  selectedIdx: number | undefined
  fetchState: 'initialize' | 'pending' | 'fulfilled' | 'rejected'
}

export const initialState: SimulationState = {
  result: undefined,
  responseCode: 0,
  selectedIdx: defaultSelectedIdx,
  fetchState: 'initialize',
}

// TODO ApiのstatusCodeによるエラー処理など
export const fetchSimulation = createAsyncThunk<SimulationRes, SimulationReq>(
  'simulation/fetchApi',
  async (arg) => {
    const response = await apiSimulation(arg)
    return response.payload
  }
)

export const simulation = createSlice({
  name: 'simulation',
  initialState,
  reducers: {
    reset: (state) => {
      return initialState
    },
    fetchMock: (state, action) => {
      state.result = {
        veryGood: { sample: 629, profit: 42006127 },
        good: { sample: 1102, principal: 3400000, profit: 24842765 },
        littleGood: { sample: 1635, principal: 3400000, profit: 14166305 },
        median: { sample: 1971, principal: 3400000, profit: 7527652 },
        littleBad: { sample: 1855, principal: 3400000, profit: 3396467 },
        bad: { sample: 1334, principal: 3400000, profit: 827856 },
        veryBad: { sample: 695, principal: 3400000, profit: -770344 },
        principal: 3400000,
        depositAmount: 3456789,
      } as SimulationResult
    },
    selectCase: (state, action: PayloadAction<number>) => {
      state.selectedIdx = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSimulation.pending, (state, action) => {
      state.fetchState = 'pending'
    })
    builder.addCase(fetchSimulation.fulfilled, (state, action) => {
      state.fetchState = 'fulfilled'
      state.responseCode = action.payload.statusCode
      state.result = action.payload.result
    })
    builder.addCase(fetchSimulation.rejected, (state, action) => {
      state.fetchState = 'rejected'
      state.result = undefined
      state.responseCode = 20
    })
  },
})

export const { reset, fetchMock, selectCase } = simulation.actions
